import { cx } from "class-variance-authority";
import { AtButton, AtButtonType, AtButtonSize } from "../../atoms/at-button";
import { MlTableMessageProps } from "./ml-table-message.types";
import { cn } from "../../../utils/cn";

export const MlTableMessage = ({
  title,
  description,
  showActionButton = false,
  actionButtonText,
  buttonHelpMessage,
  onActionClick,
  actionButtonDisabled = false,
  size = "full",
  darkerDescription = false,
}: MlTableMessageProps) => {
  const descriptionStyles = cn(
    "text-sm font-normal text-center w-full whitespace-normal",
    darkerDescription ? "text-surface-500" : "text-surface-300",
  );
  return (
    <div
      className={cn(
        "flex flex-col gap-4 items-center justify-center w-full",
        size === "full" ? "min-h-[472px]" : "min-h-[318px] ",
      )}
    >
      <div className="flex flex-col gap-1 items-center justify-center max-w-[400px] break-words">
        <h3 className="text-normal text-surface-500 font-semibold text-center">
          {title}
        </h3>
        <p className={descriptionStyles}>{description}</p>
      </div>
      {showActionButton && actionButtonText && onActionClick && (
        <div className="flex flex-col items-center justify-center">
          {buttonHelpMessage && (
            <p className={cx(descriptionStyles, "mb-2")}>{buttonHelpMessage}</p>
          )}
          <AtButton
            disabled={actionButtonDisabled}
            text={actionButtonText}
            onClick={onActionClick}
            buttonType={AtButtonType.PRIMARY}
            size={AtButtonSize.MEDIUM}
          />
        </div>
      )}
    </div>
  );
};
